// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2kTfa","amount":"Amount_amount__1-k5J","tip":"Amount_tip__p-Vd4","tipHeader":"Amount_tipHeader__1IsVZ","tipsWrap":"Amount_tipsWrap__2ZhkI"};